export default __webpack_public_path__ + "static/media/tradingview.cfd673ef.svg";